
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["home_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M982.029 404.405L573.323 83.943c-34.919-27.694-89.62-27.694-124.538 0L43.175 404.577c-13.933 11.01-16.169 31.135-5.332 44.896s31.135 16.17 44.896 5.332l13.073-10.32v387.547c0 54.873 56.937 95.984 107.853 95.984h639.892c50.228 0 84.115-38.531 84.115-95.984v-388.58l14.45 11.353c5.848 4.645 12.728 6.88 19.78 6.88 9.462 0 18.922-4.127 25.287-12.212 11.18-13.933 8.6-34.059-5.16-45.068zM607.898 797.113v66.742H415.93V684.788c0-37.155 30.103-77.234 95.984-77.234 66.053 0 95.984 40.08 95.984 77.234v112.325z"}})])
          )
        }
      }
    